import { useContext, useRef, KeyboardEvent, useEffect } from 'react';
import { InputBase } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SendOutlined from '@mui/icons-material/SendOutlined';

import { sendMessage } from '@/generated/client/messages/messages';
import { ctxMessages } from '@/contexts/MessagesCtx';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

export function Footer() {
  const ctx = useContext(ctxMessages);
  const inputRef = useRef<HTMLInputElement | undefined>(undefined);

  useEffect(() => {
    if (!inputRef.current) return;
  }, [ctx?.thread]);

  async function post(input: HTMLInputElement) {
    if (!input || !input.value || !ctx || !ctx.thread) return;

    const response = await sendMessage(ctx.thread.threadId, {
      body: input.value,
      mimeType: 'UTF8_STRING',
    });
    ctx?.setSentMessage(response.data);
    input.value = '';
  }

  // valamiert ha null megy vissza akkor nem latszik a default close ...
  if (!ctx) return;

  return (
    <div className="chat-footer">
      <span className="chat-post">
        <InputBase
          inputRef={inputRef}
          className="chat-post-input"
          onKeyUp={async (evt: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            if (evt.key === 'Enter') await post(evt.currentTarget as HTMLInputElement);
          }}
          slotProps={{
            input: {
              maxLength: 100,
            },
          }}
          autoFocus={!isPhoneOrHighScreen()}
        />
        <IconButton
          onClick={async () => {
            const inputElement = inputRef.current as HTMLInputElement;
            await post(inputElement);
          }}
        >
          <SendOutlined />
        </IconButton>
      </span>
    </div>
  );
}
